import { render, staticRenderFns } from "./CapitalAllocation.vue?vue&type=template&id=5797b7a8&scoped=true"
import script from "./CapitalAllocation.vue?vue&type=script&lang=js"
export * from "./CapitalAllocation.vue?vue&type=script&lang=js"
import style0 from "./CapitalAllocation.vue?vue&type=style&index=0&id=5797b7a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5797b7a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5797b7a8')) {
      api.createRecord('5797b7a8', component.options)
    } else {
      api.reload('5797b7a8', component.options)
    }
    module.hot.accept("./CapitalAllocation.vue?vue&type=template&id=5797b7a8&scoped=true", function () {
      api.rerender('5797b7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/CapitalAllocation.vue"
export default component.exports